import React from 'react';
import './index.scss';
// new
export const DashboardPlaceholder = () => {
  return (
    <div className='dash-item-bx dash-item-bg-1 user-select-auto placeholder-glow d-flex flex-column align-items-center w-100'>
      <span className="dash-item-title placeholder placeholder-sm w-50 rounded bg-color-plceholder"></span>
      <span className="dash-item-count w-25 text-center">
        <span className='placeholder placeholder-sm w-50 rounded bg-color-plceholder'></span>
      </span>
    </div>
  );
}
export const PublicItineraryPlaceholder = ({ count }) => {
  return (
    <div className="row">
      {Array.from({ length: Number(count) }, (_, index) => (
        <div key={index} className="placeholder-glow">
          <div className="itineraries-serach-item mt-40">
            <div className="itineraries-img-scrollbar">
              <div className="listitenaries-img-ul">
                {Array.from({ length: 8 }, (_, index) => (
                  <li key={index + 1}>
                    <div className="listitenaries-img-bx placeholder w-100 bg-color-plceholder"></div>
                  </li>
                ))}
              </div>
            </div>
            <div className="itineraries-captions-wrap">
              <div className="itineraries-title">
                <h4 className='placeholder placeholder-sm w-25 rounded bg-color-plceholder'></h4>
                <div className="itineraries-ratings">
                  <span className='placeholder btn-star rounded bg-color-plceholder'></span>
                  <span className='placeholder btn-star rounded bg-color-plceholder'></span>
                  <span className='placeholder btn-star rounded bg-color-plceholder'></span>
                  <span className='placeholder btn-star rounded bg-color-plceholder'></span>
                  <span className='placeholder btn-star rounded bg-color-plceholder'></span>
                </div>
              </div>
              <p className='placeholder placeholder-xs w-50 rounded bg-color-plceholder mt-0'></p>
              <div className="itineraries-btns">
                <div className="itineraries-btn-left">
                  <span className="placeholder placeholder-sm placeholder-btn bg-color-plceholder btn min-width-80"></span>
                  <span className="placeholder placeholder-sm placeholder-btn bg-color-plceholder btn min-width-80"></span>
                  <span className="placeholder placeholder-sm placeholder-btn bg-color-plceholder btn min-width-80"></span>
                </div>
                <div className="itineraries-btn-right">
                  <span className="placeholder placeholder-sm placeholder-btn bg-color-plceholder btn min-width-48"></span>
                  <span className="placeholder placeholder-sm placeholder-btn bg-color-plceholder btn min-width-48"></span>
                  <span className="placeholder placeholder-sm placeholder-btn bg-color-plceholder btn min-width-48"></span>
                  <span className="placeholder placeholder-sm placeholder-btn bg-color-plceholder btn min-width-48"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))
      }
    </div >
  );
}

export const PrivateItineraryPlaceholder = ({ count }) => {
  return (
    <ul className="private-itineraries-ul placeholder-glow">
      {Array.from({ length: Number(count) }, (_, index) => (
        <li key={index}>
          <p className='placeholder placeholder-xs w-50 rounded bg-color-plceholder mt-0'></p>
          <div className="pint-right">
            <div className="int-img-badge">
              <span className='rounded-circle placeholder bg-color-plceholder'></span>
              <span className='rounded-circle placeholder bg-color-plceholder'></span>
              <span className='rounded-circle placeholder bg-color-plceholder'></span>
            </div>
            <div className="int-btn-dropdown">
              <span className='rounded placeholder btn rounded-circle int-btn-info bg-color-plceholder'></span>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

export const PopularItineriesPlaceholder = () => {
  return (
    <div className="pti-item-box placeholder-glow">
      <div className="pti-item-img placeholder bg-color-plceholder w-100"></div>
      <div className="pti-item-info">
        <div className='d-flex flex-column'>
          <p className="tdf-trip-coutry placeholder placeholder-sm w-50 rounded bg-color-plceholder"></p>
          <p className="tdf-trip-days placeholder placeholder-xs w-25 rounded bg-color-plceholder mt-2"></p>
        </div>
        <div className="tdf-social-icons mt-3">
          <div className="tdf-social-icon-item">
            <span className='rounded placeholder placeholder-md col-6 h-social-25 bg-color-plceholder'></span>
          </div>
          <div className="tdf-social-icon-item">
            <span className='rounded placeholder placeholder-md col-6 h-social-25 bg-color-plceholder'></span>
          </div>
          <div className="tdf-social-icon-item">
            <span className='rounded placeholder placeholder-md col-6 h-social-25 bg-color-plceholder'></span>
          </div>
        </div>
      </div>
    </div>
  );
}

export const DestinationItineriesPlaceholder = () => {
  return (
    <div className="pti-item-box placeholder-glow">
      <div className="pti-item-img placeholder bg-color-plceholder w-100"></div>
      <div className="pti-item-info">
        <div className='d-flex flex-column'>
          <p className="tdf-trip-coutry placeholder placeholder-sm w-50 rounded bg-color-plceholder"></p>
          <p className="tdf-trip-days placeholder placeholder-xs w-25 rounded bg-color-plceholder mt-2"></p>
        </div>
      </div>
    </div>
  );
}

export const CmsPlaceholder = () => {
  return (
    Array.from({ length: 3 }, (_, index) => (
      <div key={index}>
        <div className="card-text placeholder-glow d-flex flex-column my-4">
          <span className="placeholder col-5 placeholder-lg mt-2 rounded bg-color-plceholder"></span>
          <span className="placeholder col-11 placeholder-xs mt-3 rounded bg-color-plceholder"></span>
          <span className="placeholder col-12 placeholder-xs mt-2 rounded bg-color-plceholder"></span>
          <span className="placeholder col-3 placeholder-xs mt-2 rounded bg-color-plceholder"></span>
        </div>
        <div className="card-text placeholder-glow d-flex flex-column my-4">
          <span className="placeholder col-4 placeholder-md mt-2 rounded bg-color-plceholder"></span>
          <span className="placeholder col-10 placeholder-xs mt-3 rounded bg-color-plceholder"></span>
          <span className="placeholder col-8 placeholder-xs mt-2 rounded bg-color-plceholder"></span>
          <span className="placeholder col-2 placeholder-xs mt-2 rounded bg-color-plceholder"></span>
        </div>
      </div>
    ))
  );
};

export const AccordionPlaceholder = () => {
  return (
    Array.from({ length: 3 }, (_, index) => (
      <div key={index}>
        <div className="accordion-placeholder placeholder-glow d-flex justify-content-between">
          <span className="placeholder col-4 placeholder-sm rounded bg-color-plceholder"></span>
          <span className="placeholder col-1 placeholder-sm rounded bg-color-plceholder"></span>
        </div>
        <div className="accordion-placeholder placeholder-glow d-flex justify-content-between">
          <span className="placeholder col-5 placeholder-sm rounded bg-color-plceholder"></span>
          <span className="placeholder col-1 placeholder-sm rounded bg-color-plceholder"></span>
        </div>
        <div className="accordion-placeholder placeholder-glow d-flex justify-content-between">
          <span className="placeholder col-3 placeholder-sm rounded bg-color-plceholder"></span>
          <span className="placeholder col-1 placeholder-sm rounded bg-color-plceholder"></span>
        </div>
      </div>
    ))
  );
};

export const ContactInfoPlaceholder = () => {
  return (
    <span className='placeholder-glow'>
      <span className="placeholder w-50 placeholder-xs d-inline-block rounded bg-color-plceholder"></span>
    </span>
  );
};

export const ListItemPlaceholder = ({ number }) => {
  return (
    <div className='item-row'>
      {Array.from({ length: Number(number) }, (_, index) => (
        <div key={index} className="item-block s-p-border-clr placeholder-glow">
          <div className="item-img-block">
            <div className="multi-img-block d-flex">
              <div className='multi-item w-50'>
                <span className='img-block h-img-100 w-100 placeholder bg-color-plceholder'></span>
              </div>
              <div className='multi-item w-50'>
                <div className='img-block h-img-50 placeholder bg-color-plceholder w-100'></div>
                <div className='img-block h-img-50 mt-10 placeholder bg-color-plceholder w-100'></div>
              </div>
            </div>
          </div>
          <div className="item-content-block">
            <div className="item-info">
              <h4 className='placeholder placeholder-sm col-5 rounded bg-color-plceholder'></h4>
              <p className='placeholder placeholder-sm col-9 rounded bg-color-plceholder mt-2 d-block'></p>

              <div className="list-row mt-3">
                <div className='list-col w-50'>
                  <span className='placeholder placeholder-sm col-6 rounded bg-color-plceholder'></span>
                </div>
                <div className='list-col w-50'>
                  <span className='placeholder placeholder-sm col-5 rounded bg-color-plceholder'></span>
                </div>
                <div className='list-col w-50'>
                  <span className='placeholder placeholder-sm col-5 rounded bg-color-plceholder'></span>
                </div>
                <div className='list-col w-50'>
                  <span className='placeholder placeholder-sm col-7 rounded bg-color-plceholder'></span>
                </div>
                <div className='list-col w-50'>
                  <span className='placeholder placeholder-sm col-4 rounded bg-color-plceholder'></span>
                </div>
                <div className='list-col w-50'>
                  <span className='placeholder placeholder-sm col-4 rounded bg-color-plceholder'></span>
                </div>
                <div className='list-col w-50'>
                  <span className='placeholder placeholder-sm col-5 rounded bg-color-plceholder'></span>
                </div>
                <div className='list-col w-50'>
                  <span className='placeholder placeholder-sm col-6 rounded bg-color-plceholder'></span>
                </div>
                <div className="list-col w-100 mt-2">
                  <span className='placeholder placeholder-sm w-50 rounded bg-color-plceholder'></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export const DraftListPlaceholder = ({ number }) => {
  return (
    <table className="table placeholder-glow">
      <thead>
        <tr>
          <th scope="col">
            <span className="placeholder rounded bg-color-plceholder placeholder-sm w-25"></span>
          </th>
          <th scope="col">
            <span className="placeholder rounded bg-color-plceholder placeholder-sm w-25"></span>
          </th>
          <th scope="col">
            <span className="placeholder rounded bg-color-plceholder placeholder-sm w-25"></span>
          </th>
          <th scope="col">
            <span className="placeholder rounded bg-color-plceholder placeholder-sm w-50"></span>
          </th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: Number(number) }, (_, index) => (
          <tr key={index}>
            <td className='col-5'>
              <span className="placeholder rounded w-25 bg-color-plceholder placeholder-sm"></span>
            </td>
            <td className='col-3'>
              <span className="placeholder rounded w-25 bg-color-plceholder placeholder-sm"></span>
            </td>
            <td className='col-3'>
              <span className="placeholder rounded w-25 bg-color-plceholder placeholder-sm"></span>
            </td>
            <td className='col-1'>
              <div className="d-flex align-items-center justify-content-end draft-btn-right">
                <button className="placeholder btn btn-sm bg-color-plceholder border-0"></button>
                <button className="placeholder btn btn-sm bg-color-plceholder border-0"></button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export const ItineraryPreviewPlaceholder = () => {
  return (
    <div className='placeholder-glow'>
      <div className="d-flex align-items-center mb-2">
        <span className="placeholder placeholder-lg col-3 rounded bg-color-plceholder"> </span>
      </div>
      <span className="mt-3 placeholder placeholder-sm col-2 rounded bg-color-plceholder"> </span>
      <div className="mt-3">
        <span className="placeholder placeholder-md col-4 rounded bg-color-plceholder"></span>
        <div className="row">
          {Array.from({ length: Number(6) }, (_, index) => (
            <div className="col-lg-4 mt-3" key={index}>
              <div className="civ-item-bx">
                <div className="civ-day-date d-flex justify-content-between placeholder rounded bg-color-plceholder">
                  <div>
                    <span className="civ-day-txt placeholder placeholder-md col-5 rounded bg-color-plceholder"></span>
                    <span className='placeholder placeholder-md col-5 rounded bg-color-plceholder'></span>
                  </div>
                </div>
                <div className="civ-list-row">
                  {Array.from({ length: Number(4) }, (_, index) => (
                    <div className="civ-list-item" key={index}>
                      <div className="civ-item-top-flex">
                        <div className="civ-item-img placeholder bg-color-plceholder"></div>
                        <div className="civ-item-info">
                          <div className="civ-item-icon-check mt-1">
                            <span className='placeholder placeholder-sm d-block col-3 rounded bg-color-plceholder'></span>
                          </div>
                          <span className='placeholder d-block placeholder-sm mt-2 col-5 rounded bg-color-plceholder'></span>
                          <span className="placeholder d-block placeholder-sm mt-1 col-6 rounded bg-color-plceholder"></span>
                          <span className="placeholder d-block placeholder-xs mt-2 col-3 rounded bg-color-plceholder"></span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="form-btn-groups d-flex justify-content-end mt-4">
        <span className="placeholder placeholder-sm placeholder-btn bg-color-plceholder btn min-width-48"></span>
        <span className="placeholder placeholder-sm placeholder-btn bg-color-plceholder btn min-width-48 ms-3"></span>
      </div>
    </div>
  );
};

export const ItineraryListPlaceholder = ({ number }) => {
  return (
    <>
      {Array.from({ length: Number(number) }, (_, index) => (
        <div key={index} className="listitenaries-item placeholder-glow mt-3">
          <div className="listitenaries-img-scroller">
            <ul className="listitenaries-img-ul">
              <li><span className="listitenaries-img-bx placeholder bg-color-plceholder w-100"></span></li>
              <li><span className="listitenaries-img-bx placeholder bg-color-plceholder w-100"></span></li>
              <li><span className="listitenaries-img-bx placeholder bg-color-plceholder w-100"></span></li>
              <li><span className="listitenaries-img-bx placeholder bg-color-plceholder w-100"></span></li>
              <li><span className="listitenaries-img-bx placeholder bg-color-plceholder w-100"></span></li>
              <li><span className="listitenaries-img-bx placeholder bg-color-plceholder w-100"></span></li>
              <li><span className="listitenaries-img-bx placeholder bg-color-plceholder w-100"></span></li>
              <li><span className="listitenaries-img-bx placeholder bg-color-plceholder w-100"></span></li>
            </ul>
          </div>
          <div className="listitenaries-top-bx">
            <div className="listitenaries-item-title">
              <span className='placeholder placeholder-sm d-block col-1 rounded bg-color-plceholder'></span>
              <span className="placeholder d-block placeholder-sm mt-2 col-4 rounded bg-color-plceholder"></span>
              <span className="placeholder d-block placeholder-xs mt-2 col-6 rounded bg-color-plceholder"></span>
            </div>
            <div className="listitenaries-item-btns">
              <span className="placeholder placeholder-btn bg-color-plceholder btn border-0"></span>
              <span className="placeholder placeholder-btn bg-color-plceholder btn border-0"></span>
              <span className="placeholder placeholder-btn bg-color-plceholder btn border-0"></span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export const TravelerListPlaceholder = ({ number }) => {
  return (
    <table className="table align-middle placeholder-glow">
      <thead>
        <tr>
          <th scope="col">
            <span className="placeholder rounded bg-color-plceholder placeholder-sm w-25"></span>
          </th>
          <th scope="col">
            <span className="placeholder rounded bg-color-plceholder placeholder-sm w-25"></span>
          </th>
          <th scope="col">
            <span className="placeholder rounded bg-color-plceholder placeholder-sm w-25"></span>
          </th>
          <th scope="col">
            <span className="placeholder rounded bg-color-plceholder placeholder-sm w-25"></span>
          </th>
          <th scope="col">
            <span className="placeholder rounded bg-color-plceholder placeholder-sm w-25"></span>
          </th>
          <th scope="col">
            <span className="placeholder rounded bg-color-plceholder placeholder-sm w-50"></span>
          </th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: Number(number) }, (_, index) => (
          <tr key={index}>
            <td className='col-3'>
              <span className="placeholder rounded w-25 bg-color-plceholder placeholder-sm"></span>
            </td>
            <td className='col-2'>
              <span className="placeholder rounded w-25 bg-color-plceholder placeholder-sm"></span>
            </td>
            <td className='col-2'>
              <span className="placeholder rounded w-25 bg-color-plceholder placeholder-sm"></span>
            </td>
            <td className='col-2'>
              <span className="placeholder rounded w-25 bg-color-plceholder placeholder-sm"></span>
            </td>
            <td className='col-2'>
              <span className="placeholder rounded w-25 bg-color-plceholder placeholder-sm"></span>
            </td>
            <td className='col-1'>
              <div className="d-flex align-items-center justify-content-end draft-btn-right">
                <button className="placeholder btn bg-color-plceholder border-0"></button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export const SubscriptionItemPlaceholder = ({ number }) => {
  return (
    <div className='row'>
      {Array.from({ length: Number(number) }, (_, index) => (
        <div key={index} className="col-md-4 my-3 placeholder-glow">
          <div className="subscription-item">
            <div className="subscription-item-header">
              <span className='placeholder placeholder-lg d-block col-3 mb-3 rounded bg-color-plceholder'></span>
              <span className='placeholder placeholder-sm d-block col-10 mb-2 rounded bg-color-plceholder'></span>
              <span className='placeholder placeholder-sm d-block col-7 rounded bg-color-plceholder'></span>
            </div>
            <div className="subscription-item-body">
              <div className="subscription-item-price">
                <span className='price placeholder placeholder-md d-block mt-1 col-3 rounded bg-color-plceholder'></span>
              </div>
              <span className='price placeholder placeholder-lg d-block col-12 rounded bg-color-plceholder subscription-btn'></span>
              <div className='mt-5'>
                <span className='price placeholder placeholder-sm d-block col-5 rounded bg-color-plceholder'></span>
                <span className='price placeholder placeholder-sm d-block col-7 mt-3 rounded bg-color-plceholder'></span>
                <span className='price placeholder placeholder-sm d-block col-6 mt-3 rounded bg-color-plceholder'></span>
                <span className='price placeholder placeholder-sm d-block col-7 mt-3 rounded bg-color-plceholder'></span>
              </div>
            </div>
          </div>

        </div>
      ))}
    </div>
  );
};

export const SubscriptionInfoPlaceholder = ({ number }) => {
  return (
    <>
      {Array.from({ length: Number(number) }, (_, index) => (
        <div key={index} className="col-md-5 placeholder-glow">
          <div className="card card-style-ms">
            <div className="card-header">
              <span className='placeholder placeholder-md col-4 rounded bg-color-plceholder'></span>
            </div>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                <span className='placeholder placeholder-sm my-1 col-3 rounded bg-color-plceholder'></span>
                <span className='placeholder placeholder-sm my-1 col-2 rounded bg-color-plceholder'></span>
              </li>
              <li className="list-group-item">
                <span className='placeholder placeholder-sm my-1 col-2 rounded bg-color-plceholder'></span>
                <span className='placeholder placeholder-sm my-1 col-3 rounded bg-color-plceholder'></span>
              </li>
              <li className="list-group-item">
                <span className='placeholder placeholder-sm my-1 col-3 rounded bg-color-plceholder'></span>
                <span className='placeholder placeholder-sm my-1 col-2 rounded bg-color-plceholder'></span>
              </li>
              <li className="list-group-item">
                <span className='placeholder placeholder-sm my-1 col-2 rounded bg-color-plceholder'></span>
                <span className='placeholder placeholder-sm my-1 col-3 rounded bg-color-plceholder'></span>
              </li>
            </ul>
          </div>
        </div>
      ))}
    </>
  );
};

export const SaveCardPlaceholder = ({ number }) => {
  return (
    <>
      {Array.from({ length: Number(number) }, (_, index) => (
        <div key={index} className="card-block saved-card-item placeholder-glow">
          <div className="saved-card-type">
            <span className='placeholder placeholder-md placeholder-card-img rounded bg-color-plceholder'></span>
          </div>
          <div className="saved-card-info">
            <span className='placeholder placeholder-xs d-block col-4 rounded bg-color-plceholder'></span>
            <span className='placeholder placeholder-xs d-block mt-2 col-3 rounded bg-color-plceholder'></span>
          </div>
          <div className="default-actions">
            <span className='placeholder placeholder-xs d-block btn-placeholder-card rounded-circle bg-color-plceholder'></span>
          </div>
        </div>
      ))}
    </>
  );
};

export const CreateItineraryPlaceholder = () => {
  return (
    <div className='create-iti-placeholder placeholder-glow'>
      <div className="d-span-row">
        <div className="d-col-8">
          <div className="d-col-input-field">
            <span className='placeholder placeholder-xl d-block height-46 rounded bg-color-plceholder'></span>
          </div>
          <div className="mt-3">
            <div className='row'>
              <div className='col-sm-2 mt-1'>
                <span className='placeholder placeholder-xl d-block w-100 rounded bg-color-plceholder'></span>
              </div>
              <div className='col-sm-2 mt-1'>
                <span className='placeholder placeholder-xl d-block w-100 rounded bg-color-plceholder'></span>
              </div>
              <div className='col-sm-3 mt-1'>
                <span className='placeholder placeholder-xl d-block w-100 rounded bg-color-plceholder'></span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 mt-3">
              {Array.from({ length: 2 }, (_, index) => (
                <div className="row" key={index}>
                  <div className="col-sm-4 mb-3">
                    <span className='placeholder placeholder-xl d-block height-46 rounded bg-color-plceholder'></span>
                  </div>
                  <div className="col-sm-4 mb-3">
                    <span className='placeholder placeholder-xl d-block height-46 rounded bg-color-plceholder'></span>
                  </div>
                  <div className="col-sm-4 mb-3">
                    <span className='placeholder placeholder-xl d-block height-46 rounded bg-color-plceholder'></span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="d-col-4">
          <span className='placeholder placeholder-xl col-7 rounded bg-color-plceholder'></span>
          {Array.from({ length: 3 }, (_, index) => (
            <div className="d-col-number-group d-flex mt-3" key={index}>
              <div className="number-form-label col-6">
                <span className='placeholder placeholder-xl d-block rounded bg-color-plceholder'></span>
                <span className='placeholder placeholder-sm mt-2 col-6 d-block rounded bg-color-plceholder'></span>
              </div>
              <div className="col-4">
                <span className='placeholder placeholder-xl d-block height-46 rounded bg-color-plceholder'></span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="row mt-2">
        {Array.from({ length: 3 }, (_, index) => (
          <div className="col-sm-1 mt-1" key={index}>
            <span className='placeholder placeholder-xl d-block height-46 rounded bg-color-plceholder'></span>
          </div>
        ))}
        <div className="col-sm-12 mt-3">
          <span className='placeholder placeholder-xl col-4 rounded bg-color-plceholder'></span>
        </div>
        <div className="col-sm-12 mt-3">
          <span className='placeholder placeholder-xl height-46 col-3 rounded bg-color-plceholder'></span>
        </div>
      </div>
      <div className="row mt-3">
        {Array.from({ length: 4 }, (_, index) => (
          <div className="col-sm-2 mt-1" key={index}>
            <span className='placeholder placeholder-xl d-block height-46 rounded bg-color-plceholder'></span>
          </div>
        ))}
      </div>

      {Array.from({ length: 2 }, (_, index) => (
        <div className="row mt-3" key={index}>
          <div className="col-1 d-flex align-items-center mt-1">
            <span className='placeholder placeholder-sm w-100 rounded bg-color-plceholder'></span>
          </div>
          <div className="col-8 mt-1">
            <div className="option-card w-100">
              <span className='placeholder placeholder-md option-card-img rounded-circle bg-color-plceholder'></span>
              <div className="option-card-body w-100 ps-3">
                <span className='placeholder placeholder-xs d-block col-5 rounded bg-color-plceholder'></span>
                <span className='placeholder placeholder-xs d-block mt-2 col-4 rounded bg-color-plceholder'></span>
                <span className='placeholder placeholder-xs d-block mt-2 col-2 rounded bg-color-plceholder'></span>
              </div>
            </div>
          </div>
        </div>
      ))}

    </div>
  );
};




